(function () {
  'use strict';

  var script = document.querySelector('script[data-hevisynx-part-search]');
  if (!script || script.dataset.hevisynxReady === 'true') return;
  script.dataset.hevisynxReady = 'true';

  var previewKeys = ['preview_theme_id', '_fd', 'pb'];
  var obsoleteFields = ['type', 'view', 'section_id', 'sections', 'options[prefix]', 'page'];

  function catalogTarget(form) {
    if (!form || String(form.tagName).toLowerCase() !== 'form') return null;
    if (form.hasAttribute('data-hevisynx-header-search')) return null;
    if (form.hasAttribute('data-hxu-search')) return null;
    if (!form.querySelector('input[name="q"]')) return null;
    try {
      var url = new URL(form.action, window.location.href);
      if (url.origin !== window.location.origin) return null;
      var path = url.pathname.replace(/\/$/, '');
      if (!path.endsWith('/search') && !path.endsWith('/collections/all')) return null;
      url.pathname = path.replace(/\/search$/, '/collections/all');
      url.search = '';
      url.hash = '';
      return url;
    } catch (error) {
      return null;
    }
  }

  function prepare(form) {
    var target = catalogTarget(form);
    if (!target) return null;
    form.action = target.pathname;
    form.method = 'get';
    form.querySelectorAll('[name]').forEach(function (field) {
      if (obsoleteFields.indexOf(field.name) !== -1) field.disabled = true;
    });
    var current = new URL(window.location.href);
    previewKeys.forEach(function (key) {
      if (!current.searchParams.has(key)) return;
      var field = form.querySelector('input[name="' + key + '"]');
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = key;
        form.appendChild(field);
      }
      field.value = current.searchParams.get(key);
    });
    return target;
  }

  function initialize() {
    document.querySelectorAll('form').forEach(prepare);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    var target = prepare(form);
    if (!target) return;

    event.preventDefault();
    event.stopPropagation();
    var query = form.querySelector('input[name="q"]').value.trim();
    var currentPath = window.location.pathname.replace(/\/$/, '');
    var catalogPath = target.pathname.replace(/\/$/, '');
    if ((currentPath === catalogPath || currentPath.startsWith(catalogPath + '/')) && document.querySelector('[data-hxu-catalog]')) {
      document.dispatchEvent(new CustomEvent('hevisynx:catalog-query', {
        detail: { query: query, source: 'legacy-search' }
      }));
      return;
    }

    if (query) target.searchParams.set('q', query);
    var sort = form.querySelector('[name="sort_by"]');
    if (sort && !sort.disabled && sort.value) target.searchParams.set('sort_by', sort.value);
    var current = new URL(window.location.href);
    previewKeys.forEach(function (key) {
      if (current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
    });
    window.location.assign(target.href);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
})();
